// extracted by mini-css-extract-plugin
export default {"container":"CourseFilters__container___qmpFk","searchContainer":"CourseFilters__searchContainer___c1Pdi","filtersContainer":"CourseFilters__filtersContainer___F5oks"};